import './vendor';
import './helpers';
import './components/social';
import './vendor/mobile-prevent-zoom';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import header from './components/header';
import {positionBanner} from './components/positionBanner';
import scrollToAnchor from './modules/scrollToAnchor';
import lazyLoading from './modules/lazyLoading';
import mapForm from './components/map-form';
import mapPopup from './components/map-popup';
import map from './components/map';
import modal from './components/modal';
import hero from './components/hero';

ieFix();
vhFix();

actualYear();

header.init();
scrollToAnchor.init();
lazyLoading.init();
mapForm.init();
mapPopup.init();
map.init();
modal.init();
hero.init();
setTimeout(() => {
	positionBanner();
}, 1000);

window.addEventListener('resize', () => {
	positionBanner();
});
